import Axios from 'axios'
import type {
  TCheckCustomEndpointAccessBody,
  TCheckCustomEndpointAccessRequest,
  TCheckCustomEndpointAccessResponse,
  TCreateCustomEndpointsBulkBody,
  TCreateCustomEndpointsBulkRequest,
  TCreateCustomEndpointsBulkResponse,
  TUpdateCustomEndpointBody,
  TUpdateCustomEndpointRequest,
  TUpdateCustomEndpointResponse
} from '@homepal/api-contract'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'
import {
  CustomEndpoint,
  CustomEndpointPost,
  DynamicsEntitySet
} from 'types/GlobalCustomEndpoint'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v2/connections/custom-endpoints`

export async function getAll(activeSourceId: string) {
  return getWithRedirect<CustomEndpoint[]>(`${URL}/${activeSourceId}`)
}

export async function create(body: CustomEndpointPost) {
  return Axios.post<{ data: CustomEndpoint }>(
    URL,
    { data: body },
    parseAuthenticationHeader()
  )
}

/**
 * Asks the source with the customer's stored credentials whether the
 * endpoint can be read. Not part of redux: the answer belongs to the
 * dialog or row that asked, nothing else needs it.
 */
export async function checkAccess(body: TCheckCustomEndpointAccessBody) {
  const request: TCheckCustomEndpointAccessRequest = { data: body }

  return Axios.post<TCheckCustomEndpointAccessResponse>(
    `${URL}/check-access`,
    request,
    parseAuthenticationHeader()
  )
}

/** All or nothing: the backend rejects the whole list on any conflict. */
export async function createMany(body: TCreateCustomEndpointsBulkBody) {
  const request: TCreateCustomEndpointsBulkRequest = { data: body }

  return Axios.post<TCreateCustomEndpointsBulkResponse>(
    `${URL}/bulk`,
    request,
    parseAuthenticationHeader()
  )
}

export async function update(id: string, body: TUpdateCustomEndpointBody) {
  const request: TUpdateCustomEndpointRequest = { data: body }

  return Axios.patch<TUpdateCustomEndpointResponse>(
    `${URL}/${id}`,
    request,
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}

export async function getAllDynamicsEntitySets(activeSourceId: string) {
  return getWithRedirect<DynamicsEntitySet[]>(
    `${URL}/dynamics/entity-sets/${activeSourceId}`
  )
}
